<template>
    <div class="shopifyList">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="shopifyList"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div
            :class="`table${
                (hasSearchCondition && ' has-search-condition') || ''
            }`"
        >
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
                :row-class-name="tableRowClassName"
            >
                <el-table-column type="selection" align="center">
                </el-table-column>
                <el-table-column
                    align="center"
                    width="100"
                    label="Image"
                >
                    <template slot-scope="scope">
                        <el-image
                            class="elImage_show"
                            style="height: 80px; width: 80px"
                            fit="fill"
                            :src="scope.row.goods_images[0]"
                            :previewSrcList="
                                scope.row.goods_images.length
                                    ? [
                                          scope.row.goods_images && scope.row.goods_images[0].replace(
                                              'th_',
                                              ''
                                          ),
                                      ]
                                    : ''
                            "
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                            <div slot="placeholder" class="image-slot">
                                <i class="el-icon-loading"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    property="goods_name"
                    align="left"
                    :label="$t('shopifyList.tableName.goodsInfo')"
                    min-width="200"
                >
                    <template slot-scope="scope">
                        <div class="tbItem">
                            <div class="goods-name ellipsis-2">
                                {{
                                    scope.row.goods_name
                                        ? scope.row.goods_name
                                        : ""
                                }}
                            </div>
                            <div>
                                Item ID:&nbsp;{{
                                    scope.row.itemID ? scope.row.itemID : "-"
                                }}
                            </div>
                            <div>
                                SPU:&nbsp;{{
                                    scope.row.spu ? scope.row.spu : "-"
                                }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('shopifyList.tableName.shop_name')"
                    prop="shop_name"
                    width="150"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('shopifyList.tableName.status_cn')"
                    prop="status_cn"
                    width="100"
                >
                    <!-- <template slot-scope="scope">
                        <el-tag
                            size="mini"
                            :type="
                                scope.row.status == 1
                                    ? 'success'
                                    : scope.row.status == 2
                                    ? 'warning'
                                    : 'error'
                            "
                        >
                            {{ scope.row.status_cn }}
                        </el-tag>
                    </template> -->
                    <template slot-scope="scope">
                        <span
                            class="general-table-tag"
                            :class="[
                                scope.row.status == 1
                                    ? 'info'
                                    : scope.row.status == 2
                                    ? 'warning'
                                    : 'danger',
                            ]"
                        >
                            <i class="el-icon-s-help"></i>
                            {{ scope.row.status_cn }}
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    align="left"
                    :label="$t('shopifyList.tableName.vendor')"
                    prop="vendor"
                    width="150"
                >
                </el-table-column> -->
                <el-table-column
                    align="left"
                    :label="$t('shopifyList.tableName.tags')"
                    prop="tags"
                    width="150"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('shopifyList.tableName.create_time')"
                    prop="created_at"
                    width="150"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('shopifyList.tableName.published_time')"
                    prop="published_time"
                    width="150"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('goodsList.tableName.operation')"
                    align="left"
                    width="200"
                >
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg">
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <!-- <add :addVisible.sync="addVisible"></add> -->
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
            :platform_id="platform_id"
        ></detail>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import detail from "./shoplineList/detail";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Product Name、SPU、SKU",
            searchForm: {
                goods_name: "",
                sku: "",
                itemID: "",
                published_time: "",
            },
            searchForm_transfer: {
                published_time: "",
            },
            funcName: "shoplineListing",
            //addVisible: false,
            //editVisible: false,
            detailVisible: false,
            selectList: [],
            productData: {},
            platform_id: "",
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
                shop_id: {
                    label: "Shop",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    methods: {
        /**
         * 产品新增
         */
        add() {
            this.addVisible = true;
        },
        /**
         * 获取table
         */
        shoplineListing(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .shoplineListing(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.paginationData.total = res.total;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getShopSelect(){
            cmofferApi
                .shopSelect(
                    {
                        platform_id: 4
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.advanceSearchFields.shop_id.options =
                            res.data.map((item) => {
                                return { label: item.name, value: item.id };
                            });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                if (item.funcName == "edit") {
                    this.editVisible = true;
                    this.tableItem = row;
                } else if (item.funcName == "detail") {
                    this.detailVisible = true;
                    this.tableItem = row;
                    console.log("row: ", row);
                    this.platform_id = 1;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        batchChangeStatus(item) {
            if (this.selectList.length) {
                if (item.status_flag == 2) {
                    this.$prompt(`确定${item.name}?`, "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                        inputErrorMessage: `请输入${item.name}原因`,
                        inputPlaceholder: `${item.name}原因`,
                    })
                        .then(({ value }) => {
                            cmofferApi[item.funcName](
                                {
                                    id_list: this.selectList,
                                    reason: value,
                                },
                                "put"
                            ).then((res) => {
                                if (res) {
                                    if (res.code == 200) {
                                        this.$message.success(
                                            `${item.name}成功`
                                        );
                                        this[item.parent_funcname]();
                                    }
                                }
                            });
                        })
                        .catch(() => {
                            this.$message.info("已取消操作");
                        });
                } else if (item.status_flag == 3) {
                    if (item.funcName == "batchDel") {
                        this.$confirm(`Confirm ${item.name}?`, "Tips", {
                            confirmButtonText: "Confirm",
                            cancelButtonText: "Cancel",
                            type: "warning",
                        })
                            .then(() => {
                                cmofferApi.shoplineListingDel(
                                    {
                                        id_list: this.selectList,
                                    },
                                    "post"
                                ).then((res) => {
                                    if (res) {
                                        this.$message.success(
                                            `${item.name} Success`
                                        );
                                        this[item.parent_funcname]();
                                    }
                                });
                            })
                            .catch(() => {
                                this.$message.info("Operation canceled");
                            });
                    }else{
                        this.$confirm(`确定${item.name}?`, "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            cmofferApi[item.funcName](
                                {
                                    id_list: this.selectList,
                                },
                                "put"
                            ).then((res) => {
                                if (res) {
                                    if (res.code == 200) {
                                        this.$message.success(
                                            `${item.name}成功`
                                        );
                                        this[item.parent_funcname]();
                                    }
                                }
                            });
                        })
                        .catch(() => {
                            this.$message.info("已取消操作");
                        });
                    }
                }
            } else if(item.status_flag == 3 && item.funcName == "deleteAll") {
                this.$confirm(`Confirm ${item.name}?`, "Tips", {
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    type: "warning",
                })
                .then(() => {
                    cmofferApi.shoplineListingDel(
                        {
                            id_list: [],
                            type:1
                        },
                        "post"
                    ).then((res) => {
                        if (res) {
                            this.$message.success(
                                `${item.name} Success`
                            );
                            this[item.parent_funcname]();
                        }
                    });
                })
                .catch(() => {
                    this.$message.info("Operation canceled");
                });
            } else {
                this.$message.warning("Please select before operation");
            }
        },
        /**
          清空高级搜索
        */
        clean() {
            this.searchForm = {
                goods_name: "",
                sku: "",
                itemID: "",
            };
            this.searchForm_transfer = {};
            this.advanceSearchFields = {
                shop_id:{
                    option:""
                }
            };
        },
        /**
         * 获取 sku组件回传的tags
         */
        getSkuTags(value) {
            this.searchForm.sku_list = value;
        },

        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        tableRowClassName({ row, rowIndex }) {
            let cls = "";
            for (let item of this.selectList.values()) {
                if (item === row.id) cls = "table-selectedRow-bgcolor";
            }
            return cls;
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
            this.getGoodsList(1);
        },
        closeTagsAll() {
            this.clean();
            this.getGoodsList(1);
        },
        /**
         * 中转查询条件
         */
        getGoodsList_transfer() {
            this.searchForm = Object.assign(
                this.searchForm,
                this.searchForm_transfer
            );
            this.getGoodsList();
        },
        async initialize() {
            await this.shoplineListing();
            await this.getShopSelect();
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        // add: add,
        detail,
    },
    computed: {
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.shopifyList {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 160px);
        .goods-name {
            width: 75%;
            color: $color-333333;
            margin-bottom: 10px;
        }
        .table-selectedRow-bgcolor {
            &:hover td, td {
                background-color: #f0f9eb !important;
            }
        }
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
}
</style>
